import Vue from 'vue'
import Router from 'vue-router'
import Home from "@/views/Home"
import Main from "@/views/main/Main"

/* seeting 系统设置 */

//后台用户管理
import AdminList from "@/views/settings/admin/AdminList"

//角色管理
import RoleList from "@/views/settings/role/RoleList"

//權限管理
import RuleList from "@/views/settings/rule/RuleList"

/* 登入页面 */
import Login from "@/views/Login"
// 测试
import TestList from "@/views/settings/test/TestList"

Vue.use(Router)

export default new Router({
	routes: [{
			path: '/',
			name: 'Home',
			component: Home,
			redirect: '/Main',
			children: [{
					path: '/Main',
					name: "Main",
					component: Main
				},
				/* 系统设置 */
				{
					path: '/settings/AdminList',
					name: "AdminList",
					component: AdminList,
				},
				{
					path: '/settings/RoleList',
					name: "RoleList",
					component: RoleList
				},
				{
					path: '/settings/RuleList',
					name: "RuleList",
					component: RuleList
				},
        {
        	path: '/settings/TestList',
        	name: "TestList",
        	component: TestList
        },
        {
        	path: '/settings/Test1List',
        	name: "Test1List",
        	component: () => import("@/views/settings/test1/TestList")
        },
        {
        	path: "/picture/pictureList",
        	name: "supplierOrderList",
        	component: () => import("@/views/picture/pictureList")
        },
        {
        	path: "/group/groupList",
        	name: "groupList",
        	component: () => import("@/views/group/groupList")
        },
        {
        	path: "/database/dList",
        	name: "groupList",
        	component: () => import("@/views/database/databaseList")
        },
        {
        	path: "/databasea/dList",
        	name: "groupList",
        	component: () => import("@/views/databasea/databaseList")
        },
        {
        	path: "/record/recordList",
        	name: "recordList",
        	component: () => import("@/views/record/recordList")
        },
        {
        	path: "/record/groupList",
        	name: "groupList",
        	component: () => import("@/views/record/groupList")
        },
        {
        	path: "/version/versionList",
        	name: "versionList",
        	component: () => import("@/views/version/versionList")
        },
			]
		},
		/* 登入 */
		{
			path: '/Login',
			name: "Login",
			component: Login,
		}
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js